import { User } from '../../auth/models/User';
import { AuthenticationError } from '../errors/errors';

export class AuthUserContext {
  protected static currentUser: User | null = null;
  protected static version: string | null = null;

  static getUser(): User {
    if (AuthUserContext.currentUser === null) {
      throw new AuthenticationError();
    }
    return AuthUserContext.currentUser;
  }

  static setUser(user: User) {
    AuthUserContext.currentUser = user;
  }

  static getVersion(): string | null {
    return AuthUserContext.version;
  }

  static setVersion(version: string | null) {
    AuthUserContext.version = version;
  }
}
